
import { Canvas } from "fabric";
import { cn } from "@/lib/utils";
import { Tool } from "@/hooks/use-canvas-setup";
import { ReactNode } from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface AddToolsProps {
  canvas: Canvas | null;
  onToolChange: (tool: string) => void;
  icon: ReactNode;
  label: string;
  highlight?: boolean;
}

export const AddTools = ({ canvas, onToolChange, icon, label, highlight = false }: AddToolsProps) => {
  const handleAddClick = () => {
    console.log('AddTools: handleAddClick - Changing tool to "add"');
    // This will set the activeTool to "add" which will trigger the
    // useEffect in Studio.tsx to show the LayersSidebar
    onToolChange("add");
  };
  
  return (
    <div className={cn(
      "toolbar-item",
      highlight && "animate-pulse"
    )}>
      <TooltipProvider delayDuration={300}>
        <Tooltip>
          <TooltipTrigger asChild>
            <button 
              onClick={handleAddClick}
              className={cn(
                "modern-toolbar-button add-button",
                "bg-gradient-to-br from-indigo-400 to-blue-600 text-white",
                "hover:from-indigo-500 hover:to-blue-700",
                "shadow-md hover:shadow-lg transition-all duration-300",
                "scale-110 ring-2",
                highlight ? 
                  "ring-blue-300/70 ring-offset-2 ring-offset-white/50" : 
                  "ring-blue-200/50"
              )}
              aria-label={label}
            >
              <span className="text-white">{icon}</span>
            </button>
          </TooltipTrigger>
          <TooltipContent side="bottom" className="font-medium bg-white/90 backdrop-blur-sm">
            {highlight ? "Add a scenario" : label}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};
